import Debug from 'debug';


(function($) {
	$(document).ready(function() {


        $.removeCookie('modalCount', {
            path: '/',
          });
      
          Cookies.set('modalCount', $('.modal').length, {
            expires: 7,
            path: '/',
          });
      
          const emptyarray = [];
          if (typeof Cookies.get('modalActivitiesDone') === 'undefined') {
            // console.log("Emptying modalActivitiesDone");
            Cookies.set('modalActivitiesDone', JSON.stringify(emptyarray), {
              expires: 7,
              path: '/',
            }); // for tracking completed activities
          }
          Cookies.set('currentpage', $('#pagetitle').text(), {
            expires: 7,
            path: '/',
          }); // so that we can keep our progress while visiting handbooks etc.
          // }
      
          //console.log($(".modal").length+' triggers');
      
          let inContent = 0;
          const contentDiv = $('#Content');
      
          if (parseInt(Cookies.get('modalCount')) > 0) {
            const progresshtml = '';
      
            if (typeof $('.modal')[0] !== 'undefined') {
              const modalActivitiesDone = Cookies.getJSON('modalActivitiesDone');
              let modalID = $('.modal')[0].id;
      
              let found = $.inArray(modalID, modalActivitiesDone);
              modalID = modalID.replace('_modal', '');
              modalID = modalID.replace('activity', '');
              if ($(`#${modalID}`, contentDiv).length > 0) {
                ++inContent;
                const titleID = `#myModalLabel${modalID}`;
                const title = $(titleID).text();
                const activitynum = 0;
                if (found < 0) {
                  $('#progressbar').append(
                    `<div class="trackcircle tracknotdone" activitynum="1" id="activity${
                      $('.modal')[0].id
                    }" title="${title}"><span class="${modalID}">&nbsp;&nbsp;&nbsp;&nbsp;</span></div>`,
                  );
                } else {
                  $('#progressbar').append(
                    `<div class="trackcircle trackdone" activitynum="1" id="activity${
                      $('.modal')[0].id
                    }" title="${title}"><span class="${modalID}">&nbsp;&nbsp;&nbsp;&nbsp;</span></div>`,
                  );
                }
                $(`#progressbar .${modalID}`).css('background-color', 'transparent');
                $(`#progressbar .${modalID}`).css('background-image', 'none');
                $(`#progressbar .${modalID}`).css('margin-top', '-5px');
              }
              for (let i = 0; i < parseInt(Cookies.get('modalCount')); ++i) {
                if (typeof $('.modal')[i] !== 'undefined') {
                  modalID = $('.modal')[i].id;
                //  console.log('i=' + i + ' modalID: ' + modalID);
                  found = $.inArray(modalID, modalActivitiesDone);
                  modalID = modalID.replace('_modal', '');
                  modalID = modalID.replace('activity', '');
                  //console.log('modalID: ' + modalID);
                  if ($(`.${modalID}`, contentDiv).length > 0) {
                    ++inContent;
                    const titleID = `#myModalLabel${modalID}`;
                    const title = $(titleID).text();
                    if (inContent > 1) {
                      $('#progressbar').append('<div class="trackline"></div>');
                    }
                    if (found < 0) {
                      $('#progressbar').append(
                        `<div class="trackcircle tracknotdone" activitynum="${i +
                          1}" id="activity${
                          $('.modal')[i].id
                        }" title="${title}"><span class="${modalID}">&nbsp;&nbsp;&nbsp;&nbsp;</span></div>`,
                      );
                    } else {
                      // console.log("done");
                      $('#progressbar').append(
                        `<div class="trackcircle trackdone" activitynum="${i +
                          1}" id="activity${
                          $('.modal')[i].id
                        }" title="${title}"><span class="${modalID}">&nbsp;&nbsp;&nbsp;&nbsp;</span></div>`,
                      );
                    }
                    $(`#progressbar .${modalID}`).css(
                      'background-color',
                      'transparent',
                    );
                    $(`#progressbar .${modalID}`).css('background-image', 'none');
                    $(`#progressbar .${modalID}`).css('margin-top', '-5px');
                    $(`#progressbar .${modalID}`).css('text-decoration', 'none');
                  }
                } // end if (typeof $('.modal')[i] != 'undefined')
              } // end for loop
            } // end check if (typeof $('.modal')[0] != 'undefined')
          }
      
          $('#progressbar').hide();
      
          /* this a bit of hack but it works * it's for showing and hiding the progress on bar on the patents sites */
      
          $('#Sections a[data-toggle="tab"]').on('click', e => {
            if (e.target.hash === '#Content') {
              $('#progressbar').show();
            } else {
              $('#progressbar').hide();
            }
          });
      
          /* This get the the worked example button working on the DPET unit pages*/
      
          $('.gh_workedexample_tabbutton_workexample').on('click', e => {
            $('#progressbar').toggle();
          });
      
          //* for unit on DPET.
          $('#Sections2  a[data-toggle="tab"]').on('click', e => {
            if (e.target.hash === '#Content') {
              $('#progressbar').show();
            } else {
              $('#progressbar').hide();
            }
          });
      
          // the for the new tab is IPONZ
          $('.gh__WorkedExample__page-nav a').on('click', e => {
            if (e.target.hash === '#Content') {
              $('#progressbar').show();
            } else {
              $('#progressbar').hide();
            }
          });

        
          


          // console.log(inContent+' activities in the content area (worked example)');
	
	});
})(jQuery); 


// WEBPACK FOOTER //
// Glasshouse/Core/js/ipa-modal-progress.js